module.exports = __webpack_public_path__ + "static/media/Walani_Portrait.65b027fc.png";